import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { hasRememberedSearch, listHref } from '../lastList';

/**
 * The "← All signups" link at the top of every detail page, pointing back at the
 * search you actually came from.
 *
 * It used to point at the bare list, which meant the ordinary loop — narrow to a
 * facility and a week, open a row, read it, go back, open the next row — dropped
 * the filters on every trip. Now the last search on that list is restored, and
 * the link says so, because a link that quietly does something different from
 * what it did yesterday is worse than one that says what it will do.
 *
 * Falls back to the bare path when there is nothing remembered, so it is never
 * worse than the link it replaced.
 */
export default function BackToList({ to, children }) {
  const filtered = hasRememberedSearch(to);

  return (
    <Link className="next-back" to={listHref(to)}>
      {children}
      {filtered && <span className="next-back__kept">· filters kept</span>}
    </Link>
  );
}

BackToList.propTypes = {
  // The canonical list path, e.g. `/next/signups`.
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
